import { showConfirmDialog, hideConfirmDialog } from 'src/slices/confirmDialog';

const showConfirmDialogue = (
  dispatch,
  {
    text,
    showInput,
    headerText,
    handleConfirm,
    handleCancel = null,
    confirmText = 'Yes',
    cancelText = 'No',
    ConfirmComponent,
  },
) => {
  dispatch(
    showConfirmDialog({
      props: {
        text,
        showInput,
        headerText,
        confirmText,
        cancelText,
        ConfirmComponent,
        isOpen: true,
        handleClose: (isConfirmed, data) => {
          dispatch(hideConfirmDialog());
          if (isConfirmed) {
            handleConfirm(data);
          } else if (handleCancel) {
            handleCancel();
          }
        },
      },
    }),
  );
};

export default showConfirmDialogue;
